(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rr-about-shared"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('rr-about-page')){customElements.define('rr-about-page',class extends HTMLElement{connectedCallback(){this.controller?.abort();this.controller=new AbortController();const header=()=>document.body.classList.toggle('rr-about-scrolled',Math.max(window.scrollY,this.closest('.page-wrapper')?.scrollTop||0)>24);document.addEventListener('scroll',header,{capture:true,passive:true,signal:this.controller.signal});header()}disconnectedCallback(){this.controller?.abort();document.body.classList.remove('rr-about-scrolled')}})}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rr-collection-shared"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('rr-collection-header'))customElements.define('rr-collection-header',class extends HTMLElement{connectedCallback(){this.controller?.abort();this.controller=new AbortController();const update=()=>document.body.classList.toggle('rr-collection-scrolled',Math.max(window.scrollY,this.closest('.page-wrapper')?.scrollTop||0)>24);document.addEventListener('scroll',update,{capture:true,passive:true,signal:this.controller.signal});update()}disconnectedCallback(){this.controller?.abort();document.body.classList.remove('rr-collection-scrolled')}});
if(!customElements.get('rr-collection-grid'))customElements.define('rr-collection-grid',class extends HTMLElement{
 connectedCallback(){this.controller?.abort();this.controller=new AbortController();const signal=this.controller.signal;const toggle=this.querySelector('[data-filter-toggle]');const panel=this.querySelector('.cl-filters');toggle?.addEventListener('click',()=>{panel.hidden=!panel.hidden;toggle.setAttribute('aria-expanded',String(!panel.hidden))},{signal});const form=this.querySelector('form');const preview=new URLSearchParams(location.search).get('preview_theme_id');if(preview){const input=document.createElement('input');input.type='hidden';input.name='preview_theme_id';input.value=preview;form.append(input)}this.querySelector('[data-sort]')?.addEventListener('change',()=>form.requestSubmit(),{signal});this.addEventListener('click',e=>{const swatch=e.target.closest('[data-color]');if(!swatch||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;e.preventDefault();const card=swatch.closest('.cl-card');const img=card.querySelector('.cl-photo img');if(swatch.dataset.image&&img){img.removeAttribute('srcset');img.src=swatch.dataset.image;img.alt=swatch.getAttribute('aria-label')}card.querySelectorAll('[data-product-link]').forEach(a=>a.href=swatch.href);card.querySelectorAll('[data-color]').forEach(a=>a.removeAttribute('aria-current'));swatch.setAttribute('aria-current','true');card.querySelector('[data-color-label]').textContent=swatch.dataset.color},{signal})}
 disconnectedCallback(){this.controller?.abort()}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rr-community-shared"] && !Shopify.designMode) return;
  try {
    (() => {
 const define=(name,cls)=>{if(!customElements.get(name))customElements.define(name,cls)};
 const motion=()=>matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth';
 define('rr-community-header',class extends HTMLElement{
  connectedCallback(){this.controller?.abort();this.controller=new AbortController();const update=()=>document.body.classList.toggle('rr-community-scrolled',Math.max(window.scrollY,this.closest('.page-wrapper')?.scrollTop||0)>24);document.addEventListener('scroll',update,{capture:true,passive:true,signal:this.controller.signal});update()}
  disconnectedCallback(){this.controller?.abort();document.body.classList.remove('rr-community-scrolled')}
 });
 define('rr-community-partners',class extends HTMLElement{
  connectedCallback(){this.controller?.abort();this.controller=new AbortController();document.addEventListener('rr:community-ready',()=>this.update(),{signal:this.controller.signal});document.addEventListener('shopify:section:unload',()=>queueMicrotask(()=>this.update()),{signal:this.controller.signal});queueMicrotask(()=>this.update())}
  disconnectedCallback(){this.controller?.abort()}
  update(){const directory=document.querySelector('rr-community-directory');const templates=[...(directory?.querySelectorAll('[data-feature-template]')||[])];const target=this.querySelector('[data-featured-groups]');target.replaceChildren(...templates.map(t=>t.content.cloneNode(true)));this.hidden=!templates.length&&this.dataset.editor!=='true';const empty=this.querySelector('[data-partner-empty]');if(empty)empty.hidden=templates.length>0;this.querySelector('[data-partner-demo]').hidden=!templates.some(t=>t.closest('[data-group]').dataset.sample==='true');target.querySelectorAll('[data-feature-link]').forEach(link=>link.addEventListener('click',()=>directory?.selectFromFeature(link.dataset.featureLink)))}
 });
 define('rr-community-directory',class extends HTMLElement{
  connectedCallback(){
   this.controller?.abort();this.controller=new AbortController();const {signal}=this.controller;
   this.groups=[...this.querySelectorAll('[data-group]')];this.filters=[...this.querySelectorAll('[data-filter]')];this.partner=this.querySelector('[data-partners-only]');this.active=this.groups[0]?.dataset.group;this.zoomed=false;
   this.querySelectorAll('[data-controls]').forEach(el=>el.hidden=false);
   this.filters.forEach(select=>{const key=select.dataset.filter;while(select.options.length>1)select.remove(1);[...new Set(this.groups.map(g=>g.dataset[key]).filter(Boolean))].sort().forEach(v=>select.add(new Option(v,v)));select.addEventListener('change',()=>{this.zoomed=false;this.update()},{signal})});
   this.partner.addEventListener('change',()=>{this.zoomed=false;this.update()},{signal});
   this.querySelector('[data-reset]').addEventListener('click',()=>this.reset(),{signal});
   this.querySelectorAll('[data-select]').forEach(button=>button.addEventListener('click',()=>{this.active=button.dataset.select;this.update()},{signal}));
   this.querySelector('[data-zoom]').addEventListener('click',()=>{this.zoomed=!this.zoomed;this.update()},{signal});
   document.addEventListener('shopify:block:select',e=>{if(this.groups.some(g=>g.dataset.group===e.detail?.blockId)){this.selectFromFeature(e.detail.blockId)}},{signal});
   this.drawPins();this.update();document.dispatchEvent(new CustomEvent('rr:community-ready'));
  }
  disconnectedCallback(){this.controller?.abort();queueMicrotask(()=>document.dispatchEvent(new CustomEvent('rr:community-ready')))}
  reset(){this.filters.forEach(s=>s.value='');this.partner.checked=false;this.zoomed=false;this.update()}
  selectFromFeature(id){this.reset();this.active=id;this.update()}
  coordinates(group){
   const lat=Number(group.dataset.lat),lon=Number(group.dataset.lon);
   if(!group.dataset.lat?.trim()||!group.dataset.lon?.trim()||!Number.isFinite(lat)||!Number.isFinite(lon)||lat<24||lat>50||lon< -125||lon> -66)return null;
   const rad=Math.PI/180,n=(Math.sin(29.5*rad)+Math.sin(45.5*rad))/2,c=Math.cos(29.5*rad)**2+2*n*Math.sin(29.5*rad),r=Math.sqrt(c-2*n*Math.sin(lat*rad))/n,t=n*(lon+96)*rad;
   const x=1094.38989339*r*Math.sin(t)+443.65769566,y=1094.38989339*r*Math.cos(t)-1123.48418448;
   return x>=0&&x<=1000&&y>=0&&y<=560?[x,y]:null;
  }
  drawPins(){
   const ns='http://www.w3.org/2000/svg',layer=this.querySelector('[data-pins]');layer.replaceChildren();this.pins=new Map();
   const svg=(tag,attrs)=>{const el=document.createElementNS(ns,tag);for(const [k,v]of Object.entries(attrs))el.setAttribute(k,String(v));return el};
   this.groups.forEach((group,i)=>{
    const xy=this.coordinates(group);if(!xy)return;
    const pin=svg('g',{class:'co-pin'+(group.dataset.partner==='true'?' partner':''),role:'button',tabindex:0,'aria-label':group.dataset.name+', '+group.dataset.city,transform:'translate('+xy.join(',')+')'});
    pin.append(svg('rect',{x:-24,y:-24,width:48,height:48,fill:'transparent'}),svg('circle',{r:24,class:'co-pin-halo'}),svg('circle',{r:13}));
    const label=svg('text',{y:4,'text-anchor':'middle',class:'co-pin-number'});label.textContent=String(i+1).padStart(2,'0');pin.append(label);
    const city=svg('text',{x:22,y:6,class:'co-city'});city.textContent=group.dataset.city;pin.append(city);
    const select=()=>{this.active=group.dataset.group;this.update()};
    pin.addEventListener('click',select);pin.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();select()}});
    this.pins.set(group.dataset.group,pin);layer.append(pin);
   });
  }
  update(){
   const visible=this.groups.filter(g=>this.filters.every(s=>!s.value||g.dataset[s.dataset.filter]===s.value)&&(!this.partner.checked||g.dataset.partner==='true'));
   if(!visible.some(g=>g.dataset.group===this.active))this.active=visible[0]?.dataset.group;
   this.groups.forEach(g=>{const show=visible.includes(g),active=g.dataset.group===this.active;g.hidden=!show;const button=g.querySelector('[data-select]');button.classList.toggle('active',active);button.setAttribute('aria-expanded',String(active));g.querySelector('[data-detail]').hidden=!active;const pin=this.pins.get(g.dataset.group);if(pin){pin.style.display=show?'':'none';pin.setAttribute('tabindex',show?'0':'-1');pin.classList.toggle('selected',active);pin.setAttribute('aria-pressed',String(active))}});
   this.querySelector('[data-count]').textContent=visible.length+' '+this.dataset.countText;
   this.querySelector('[data-no-matches]').hidden=visible.length>0;
   this.querySelector('[data-directory-content]').hidden=this.groups.length===0;
   this.querySelector('[data-no-groups]').hidden=this.groups.length>0;
   const current=visible.find(g=>g.dataset.group===this.active),xy=current?this.coordinates(current):null,zoom=this.querySelector('[data-zoom]');
   zoom.disabled=!xy;zoom.textContent=this.zoomed&&xy?'−':'+';zoom.setAttribute('aria-label',this.zoomed&&xy?this.dataset.fullMap:this.dataset.zoomMap);
   this.querySelector('.co-map').setAttribute('viewBox',this.zoomed&&xy?[Math.max(0,Math.min(500,xy[0]-250)),Math.max(0,Math.min(280,xy[1]-140)),500,280].join(' '):'0 0 1000 560');
   this.querySelector('[data-map-place]').textContent=current?[current.dataset.city,current.dataset.state].filter(Boolean).join(', '):'';
   this.querySelector('[data-map-intro]').textContent=current?.querySelector('[data-intro]')?.textContent||'';
  }
 });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rr-contact-shared"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rr-contact-page')) {
 customElements.define('rr-contact-page',class extends HTMLElement {
  connectedCallback(){
   this.controller?.abort();this.controller=new AbortController();const {signal}=this.controller;
   const header=()=>document.body.classList.toggle('rr-contact-scrolled',Math.max(window.scrollY,this.closest('.page-wrapper')?.scrollTop||0)>24);
   document.addEventListener('scroll',header,{capture:true,passive:true,signal});header();
   const topic=this.querySelector('[data-contact-topic]');
   if(topic){
    const requested=new URLSearchParams(location.search).get('topic');
    if(requested&&[...topic.options].some(o=>o.dataset.topic===requested)){topic.selectedIndex=[...topic.options].findIndex(o=>o.dataset.topic===requested)}
    const update=()=>{
     const value=topic.options[topic.selectedIndex].dataset.topic;
     this.querySelectorAll('[data-contact-panel]').forEach(panel=>{
      const show=panel.dataset.contactPanel===value;panel.hidden=!show;
      panel.querySelectorAll('input').forEach(input=>{input.disabled=!show;input.required=show&&input.hasAttribute('data-required-when-visible')});
     });
     const label=this.querySelector('[data-contact-message-label]');label.textContent=value==='group'?label.dataset.group:label.dataset.default;
    };
    topic.addEventListener('change',update,{signal});update();
   }
   const result=this.querySelector('[data-contact-result]');if(result){result.focus({preventScroll:true});result.scrollIntoView({block:'center',behavior:'auto'})}
  }
  disconnectedCallback(){this.controller?.abort();document.body.classList.remove('rr-contact-scrolled')}
 });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rr-fit-shared"] && !Shopify.designMode) return;
  try {
    (() => {
  const motion = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  const define = (name, cls) => { if (!customElements.get(name)) customElements.define(name, cls); };
  const measurementKeys = ['height','waist','hips','inseam','chest'];
  function distance(card, match) {
    if (!match) return 0;
    let score = 0;
    for (const key of measurementKeys) {
      const target = match.values[key];
      if (!target) continue;
      const value = Number(card.dataset[key]);
      if (!value || !Number.isFinite(value)) return Infinity;
      const weight = key === 'height' ? 1.5 : (key === 'hips' && match.focus !== 'top') || (key === 'chest' && match.focus !== 'bottom') ? 2 : 1;
      score += Math.abs(value - target) * weight;
    }
    return score;
  }
  function fits(card, filters) {
    return Object.entries(filters).every(([key,value]) => !value || (key === 'height' ? Number(card.dataset.height) > 0 && (value === 'short' ? Number(card.dataset.height) < 66 : Number(card.dataset.height) >= 66) : card.dataset[key] === value));
  }
  define('rr-fit-charts', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return; this.ready = true;
      const select = this.querySelector('[data-chart-select]');
      select.disabled = select.options.length === 0;
      const update = () => this.querySelectorAll('[data-chart-panel]').forEach(panel => panel.hidden = panel.dataset.chartPanel !== select.value);
      select.addEventListener('change',update); update();
      this.scrollController = new AbortController();
      const header = () => document.body.classList.toggle('rr-fit-scrolled',window.scrollY > 24);
      window.addEventListener('scroll',header,{passive:true,signal:this.scrollController.signal}); header();
    }
    disconnectedCallback() { this.scrollController?.abort(); this.ready=false; document.body.classList.remove('rr-fit-scrolled'); }
  });
  define('rr-fit-photos', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return; this.ready = true;
      const track = this.querySelector('.fit-photo-track');
      const go = index => track.scrollTo({left:index * track.clientWidth,behavior:motion()});
      const update = () => {
        const index = Math.round(track.scrollLeft / Math.max(1,track.clientWidth));
        this.querySelectorAll('[data-photo]').forEach(button => {
          if (button.hasAttribute('aria-pressed')) button.setAttribute('aria-pressed',String(Number(button.dataset.photo) === index));
          if (button.dataset.end !== undefined) button.disabled = Number(button.dataset.end) === index;
        });
      };
      this.querySelectorAll('[data-photo]').forEach(button => button.addEventListener('click',() => go(Number(button.dataset.photo))));
      track.addEventListener('scroll',update,{passive:true});
      track.addEventListener('keydown',e => { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {e.preventDefault();go(e.key === 'ArrowRight' ? 1 : 0);} });
    }
  });
  define('rr-fit-matcher', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return; this.ready = true;
      const form = this.querySelector('form');
      const error = this.querySelector('[data-match-error]');
      let units = form.elements.units.value;
      form.elements.units.addEventListener('change',() => {
        const next = form.elements.units.value;
        for (const key of measurementKeys) {
          const input = form.elements[key];
          if (input.value) input.value = String(Math.round(Number(input.value) * (next === 'cm' ? 2.54 : 1/2.54) * 10) / 10);
          input.max = next === 'cm' ? '305' : '120';
        }
        units = next;
      });
      form.addEventListener('submit',e => {
        e.preventDefault();
        const values = Object.fromEntries(measurementKeys.map(key=>[key,Number(form.elements[key].value) / (units === 'cm' ? 2.54 : 1)]));
        error.hidden = Object.values(values).some(n => n > 0 && Number.isFinite(n));
        if (!error.hidden) return;
        this.match = {values,focus:form.elements.focus.value};
        document.dispatchEvent(new CustomEvent('rr:fit-match',{detail:this.match}));
      });
      form.addEventListener('reset',() => {
        this.match = null; units = 'in'; error.hidden = true;
        measurementKeys.forEach(key => form.elements[key].max = '120');
        document.dispatchEvent(new CustomEvent('rr:fit-match',{detail:null}));
      });
    }
    disconnectedCallback() { document.dispatchEvent(new CustomEvent('rr:fit-match',{detail:null})); }
  });
  define('rr-fit-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      const {signal} = this.controller;
      this.cards = Array.from(this.querySelectorAll('[data-rider]'));
      this.grid = this.querySelector('.fit-profile-grid');
      this.match = document.querySelector('rr-fit-matcher')?.match || null;
      this.querySelectorAll('[data-filter]').forEach(select => select.addEventListener('change',()=>this.update(),{signal}));
      this.querySelectorAll('[data-clear-filters]').forEach(button => button.addEventListener('click',() => {
        this.querySelectorAll('[data-filter]').forEach(select=>select.value=''); this.update();
      },{signal}));
      document.addEventListener('rr:fit-match',e=>{this.match=e.detail;this.update();},{signal});
      this.populate(); this.update(); this.loadMore(signal);
    }
    disconnectedCallback() { this.controller?.abort(); }
    populate() {
      for (const key of ['top','topSize','bottom','bottomSize']) {
        const select=this.querySelector(`[data-filter="${key}"]`), selected=select.value;
        while(select.options.length>1) select.remove(1);
        const values=new Map(this.cards.map(card=>[card.dataset[key],card.dataset[key+'Label'] || card.dataset[key]]));
        const order=['XXS','XS','S','M','L','XL','XXL','XXXL'];
        [...values].filter(([v])=>v).sort((a,b)=>key.includes('Size') ? (order.indexOf(a[0])+1 || 99)-(order.indexOf(b[0])+1 || 99) : a[1].localeCompare(b[1])).forEach(([v,label])=>select.add(new Option(label,v)));
        select.value=selected;
      }
    }
    update() {
      const filters=Object.fromEntries([...this.querySelectorAll('[data-filter]')].map(select=>[select.dataset.filter,select.value]));
      const ordered=[...this.cards].sort((a,b)=>distance(a,this.match)-distance(b,this.match));
      let count=0;
      ordered.forEach(card=>{card.hidden=!fits(card,filters);if(!card.hidden)count++;this.grid.append(card);});
      this.querySelector('[data-results]').textContent=`${count} ${this.dataset.countText}${this.match ? ' · '+this.dataset.sortedText : ''}`;
      this.querySelector('[data-empty]').hidden=this.cards.length>0;
      this.querySelector('[data-no-matches]').hidden=!this.cards.length || count>0;
    }
    async loadMore(signal) {
      let link=this.querySelector('[data-more-riders]');
      const seen=new Set();
      try {
        while(link && !signal.aborted) {
          const url=new URL(link.href,location.href);
          if(url.origin!==location.origin || seen.has(url.href)) break;
          seen.add(url.href);
          this.querySelector('[data-results]').textContent=this.dataset.loadingText;
          const response=await fetch(url,{signal});
          if(!response.ok)throw new Error('profiles');
          const page=new DOMParser().parseFromString(await response.text(),'text/html');
          const gallery=page.querySelector('rr-fit-gallery');
          if(!gallery)throw new Error('gallery');
          gallery.querySelectorAll('[data-rider]').forEach(card=>{const imported=document.importNode(card,true);this.cards.push(imported);this.grid.append(imported);});
          const next=gallery.querySelector('[data-more-riders]');
          link.remove(); if(next){link=document.importNode(next,true);this.append(link);}else link=null;
        }
        if(!signal.aborted){this.populate();this.update();}
      } catch(error) {
        if(error.name==='AbortError')return;
        this.populate();this.update();this.querySelector('[data-results]').textContent+=' · '+this.dataset.loadError;
      }
    }
  });
  define('rr-catalogue-row', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return; this.ready=true;
      const track=this.querySelector('.rr-tops-catalog__products');
      const buttons=[...this.querySelectorAll('[data-direction]')];
      const update=()=>buttons.forEach(button=>button.disabled=Number(button.dataset.direction)<0 ? track.scrollLeft<2 : track.scrollLeft+track.clientWidth>=track.scrollWidth-2);
      buttons.forEach(button=>button.addEventListener('click',()=>track.scrollBy({left:Number(button.dataset.direction)*track.clientWidth,behavior:motion()})));
      track.addEventListener('scroll',update,{passive:true});
      this.observer=new ResizeObserver(update); this.observer.observe(track);update();
    }
    disconnectedCallback(){this.observer?.disconnect();this.ready=false;}
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rr-share-styles"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rr-share-header')) {
 customElements.define('rr-share-header',class extends HTMLElement {
  connectedCallback(){this.controller?.abort();this.controller=new AbortController();const update=()=>document.body.classList.toggle('rr-share-scrolled',Math.max(window.scrollY,this.closest('.page-wrapper')?.scrollTop||0)>24);document.addEventListener('scroll',update,{passive:true,capture:true,signal:this.controller.signal});update();}
  disconnectedCallback(){this.controller?.abort();document.body.classList.remove('rr-share-scrolled');}
 });
}
  } catch(e) { console.error(e); }
})();

})();
